"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesAccordion = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const router_1 = require("next/router");
const styled_components_1 = __importDefault(require("styled-components"));
const framer_motion_1 = require("framer-motion");
const styles_1 = require("../styles");
const getSubcategories = (subcategories, locale, menuMobile, closeMenuMobile, querySubCat, isExpanded, brandCategory, pageCategory) => {
    if (subcategories.length < 1)
        return null;
    return subcategories.map((subcategory, idx) => {
        var _a, _b;
        const slug = (_a = subcategory === null || subcategory === void 0 ? void 0 : subcategory.slug) === null || _a === void 0 ? void 0 : _a[locale];
        if (typeof slug !== 'string')
            return false;
        const url = brandCategory.length > 0 ? `/brand/${brandCategory}/${slug}` : pageCategory.length > 0 ? `/page/${pageCategory}/${slug}` : `/catalog/${slug}`;
        const isActive = (slug && querySubCat) ? querySubCat === ((_b = slug === null || slug === void 0 ? void 0 : slug.split('/')) === null || _b === void 0 ? void 0 : _b[1]) : false;
        return ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.dd, Object.assign({ variants: itemVariants }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: url }, (menuMobile && { onClick: closeMenuMobile }), { className: `${isActive ? 'is-active' : ''}` }, { children: subcategory.name })) }), `subcategory-item-${idx}-${isExpanded}`));
    });
};
const CategoryAccordionItem = (0, react_1.memo)(({ category, menuMobile, closeMenuMobile, brandCategory, pageCategory }) => {
    var _a, _b;
    const { locale: routerLocale, query } = (0, router_1.useRouter)();
    const lang = (0, react_1.useMemo)(() => routerLocale.split('-')[0], [routerLocale]);
    const slug = category.slug[lang] ? category.slug[lang] : category.slug;
    const url = brandCategory.length > 0 ? category.isInformativeText ? null : category.isFirstCategory ? `/brand/${slug}` : `/brand/${brandCategory}/${slug}` : pageCategory.length > 0 ? pageCategory.split('/')[0].includes(slug) ? `/page/${slug}` : `/page/${pageCategory}/${slug}` : `/catalog/${slug}`;
    const isActive = (0, react_1.useMemo)(() => { var _a; return ((_a = query === null || query === void 0 ? void 0 : query.slug) === null || _a === void 0 ? void 0 : _a[0]) === slug; }, [query, slug]);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(isActive);
    const Subcategories = (0, react_1.useMemo)(() => { var _a; return getSubcategories(category.subcategories, lang, menuMobile, closeMenuMobile, (_a = query === null || query === void 0 ? void 0 : query.slug) === null || _a === void 0 ? void 0 : _a[1], isExpanded, brandCategory, pageCategory); }, [category.subcategories, lang, menuMobile, closeMenuMobile, query, isExpanded, brandCategory, pageCategory]);
    const onClick = () => {
        setIsExpanded(!isExpanded);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(framer_motion_1.motion.dt, Object.assign({ variants: itemVariants }, { children: [url ?
                        (0, jsx_runtime_1.jsx)("a", Object.assign({ href: url }, (menuMobile && { onClick: closeMenuMobile }), { className: `${isActive ? 'is-active' : ''}` }, { children: category.name }))
                        :
                            (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'informative' }, { children: category.name })), ((_a = category.subcategories) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        (0, jsx_runtime_1.jsx)(Chevron, Object.assign({ menuMobile: menuMobile, onClick: onClick, "aria-hidden": true, animate: { rotate: isExpanded ? 90 : 0 }, transition: ChevronTransition }, { children: (0, jsx_runtime_1.jsx)("img", { src: `/images/svg/i--chevron${menuMobile ? '--white' : ''}.svg`, alt: 'Icon chevron', width: '6', height: '8' }) }))] })), ((_b = category.subcategories) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                (0, jsx_runtime_1.jsx)(Div, Object.assign({ "aria-expanded": isExpanded, tabIndex: -1, variants: variants, initial: 'inactive', exit: 'exit', animate: isExpanded ? 'active' : 'exit' }, { children: Subcategories }))] }));
});
const getCategories = (categories, menuMobile, closeMenuMobile, path, brandCategory, pageCategory) => {
    return categories.map((category, idx) => {
        return ((0, jsx_runtime_1.jsx)(CategoryAccordionItem, { category: category, menuMobile: menuMobile, closeMenuMobile: closeMenuMobile, brandCategory: brandCategory, pageCategory: pageCategory }, `cat-item-${idx}-${path}`));
    });
};
exports.CategoriesAccordion = (0, react_1.memo)(({ categories = [], menuMobile = false, closeMenuMobile = null, decreaseLevel = null, brandCategory = '', pageCategory = '' }) => {
    const { asPath } = (0, router_1.useRouter)();
    const Categories = (0, react_1.useMemo)(() => getCategories(categories, menuMobile, closeMenuMobile, asPath, brandCategory, pageCategory), [categories, menuMobile, closeMenuMobile, asPath, brandCategory, pageCategory]);
    return ((0, jsx_runtime_1.jsxs)(Dl, Object.assign({ menuMobile: menuMobile, initial: 'inactive', animate: 'active', exit: 'exit', variants: listVariants }, { children: [menuMobile &&
                (0, jsx_runtime_1.jsx)(framer_motion_1.motion.dt, Object.assign({ variants: itemVariants }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ className: 'go-back', onClick: decreaseLevel }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--go-back--white.svg', alt: 'Icon back', width: '7', height: '12' }) })) })), Categories] })));
});
const Dl = (0, styled_components_1.default)(framer_motion_1.motion.dl) `
  display: flex;
  flex-direction: column;
  padding:  ${({ menuMobile }) => menuMobile ? `0 ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(100, 'mobile')}` : 0};
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    padding:  ${({ menuMobile }) => menuMobile ? `0 ${(0, styles_1.vw)(20, 'nexus7')} ${(0, styles_1.vw)(100, 'nexus7')}` : 0};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: ${({ menuMobile }) => menuMobile ? `0 ${(0, styles_1.vw)(20, 'desktop')}` : 0};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: ${({ menuMobile }) => menuMobile ? '0 20px' : 0};
  }

  dt {
    align-items: center;
    display: flex;
    height: ${(0, styles_1.vw)(65, 'mobile')};
    justify-content: space-between;
    flex-shrink: 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(65, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(45, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 45px;
    }

    &:active,
    &:focus {
      outline: 0;
    }

    a,
    button {
      &:active,
      &:focus {
        outline: 0;
      }
    }

    a {
      font-family: ${({ theme }) => theme.fonts.primaryFont};
      font-weight: bold;
      width: 100%;

      ${styles_1.mq.greaterThan('tablet')} {
        font-family: ${({ theme }) => theme.fonts.secondaryFont};
        font-weight: 500;
      }
    }

    button {
      flex-shrink: 0;
      justify-content: center;

      ${styles_1.mq.greaterThan('tablet')} {
        margin-left: ${(0, styles_1.vw)(30, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        margin-left: 30px;
      }

      &.go-back {
        margin-left: 0;

        ${styles_1.mq.greaterThan('tablet')} {
          display: none;
        }

        img {
          height: ${(0, styles_1.vw)(20, 'mobile')};
          width: ${(0, styles_1.vw)(12, 'mobile')};
        }
      }
    }
  }

  dd {
    align-items: center;
    display: flex;
    height: ${(0, styles_1.vw)(50, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(50, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(40, 'desktop')};
      padding: 0 ${(0, styles_1.vw)(20, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 40px;
      padding: 0 20px;
    }

    &:active,
    &:focus {
      outline: 0;
    }

    &:last-child {
      margin-bottom: ${(0, styles_1.vw)(10, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        margin-bottom: ${(0, styles_1.vw)(10, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        margin-bottom: ${(0, styles_1.vw)(10, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        margin-bottom: 10px;
      }
    }

    a {
      font-family: ${({ theme }) => theme.fonts.secondaryFont};
      opacity: ${({ menuMobile }) => menuMobile ? 1 : .5};
      transition: 300ms opacity ${({ ease }) => ease};
      font-weight: 500;

      &.is-active {
        opacity: 1;
      }

      &:hover {
        opacity: 1;
      }
    }
  }

  dt, dd {
    a {
      align-items: center;
      color: ${({ theme, menuMobile }) => theme.colors[menuMobile ? 'white' : 'darkred']};
      display: flex;
      height: 100%;
      justify-content: flex-start;
    }
  }

  dt {
    a {
      ${(0, styles_1.getP18)()}
      &.is-active {
        color: ${({ theme }) => theme.colors.creme};
      }
    }
  }
  dd {
    a {
      ${(0, styles_1.getP15_2B)()}
    }
  }
  .informative {
    ${(0, styles_1.getP15)()}
    font-family: ${({ theme }) => theme.fonts.secondaryFont};
    opacity: .5;
  }
`;
const Chevron = (0, styled_components_1.default)(framer_motion_1.motion.button) `
  align-items: center;
  display: flex;
  height: ${(0, styles_1.vw)(45, 'mobile')};
  padding: ${(0, styles_1.vw)(10, 'mobile')};
  width: ${(0, styles_1.vw)(45, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(45, 'nexus7')};
    padding: ${(0, styles_1.vw)(10, 'nexus7')};
    width: ${(0, styles_1.vw)(45, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${(0, styles_1.vw)(45, 'desktop')};
    padding: ${(0, styles_1.vw)(10, 'desktop')};
    width: ${(0, styles_1.vw)(45, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    height: 45px;
    padding: 10px;
    width: 45px;
  }

  img {
    height: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'mobile')};
    width: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'nexus7')};
      width: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(9, 'desktop')};
      width: ${(0, styles_1.vw)(9, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 9px;
      width: 9px;
    }
  }
`;
const Div = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  dd, a, button {
    transition: opacity 300ms ease-out;
  }

  &[aria-expanded=false] {
    /* overflow: hidden; */

    dd, a, button {
      opacity: 0;
      pointer-events: none;
      user-select: none;
    }
  }
`;
const transition = Object.assign({}, (0, styles_1.getTransition)());
const listVariants = {
    inactive: {
        opacity: 0,
        transition
    },
    active: {
        opacity: 1,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { staggerChildren: .01 })
    },
    exit: {
        opacity: 0,
        transition
    }
};
const itemVariants = {
    inactive: {
        x: -10,
        opacity: 0,
        transition
    },
    active: {
        x: 0,
        opacity: 1,
        transition
    },
    exit: {
        opacity: 0
    }
};
const variants = {
    inactive: {
        height: 0,
        opacity: 0,
        transition: Object.assign({}, (0, styles_1.getTransition)())
    },
    active: {
        height: 'auto',
        opacity: 1,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { staggerChildren: .01 })
    },
    exit: {
        height: 0,
        opacity: 0,
        transition: Object.assign({}, (0, styles_1.getTransition)())
    },
};
const ChevronTransition = {
    ease: [.25, .1, .25, 1],
    duration: .3,
    type: 'tween'
};
